import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { FrontendHero } from '../../components/frontend/home';
import { useTheme } from '@material-ui/core';
import { FilterBuilder } from '@loopback/filter';
import useAuth from '../../hooks/useAuth';
import useAPI from '../../hooks/useAPI';
import { conciergeServicesApi } from '../../actions/conciergeServicesApi';
import useSettings from '../../hooks/useSettings';
import { THEMES } from '../../constants';
const Home = () => {
  const theme = useTheme()
  const { isAuthenticated } = useAuth()
  const [categories, setCategories] = useState([])
  const [services, setServices] = useState([])
  const { api } = useAPI();
  const { settings } = useSettings()
  const [serviceUsedCounts, setServiceUsedCounts] = useState([])

  useEffect(() => {
    if (isAuthenticated) {
      const getCats = async () => {
        const catFilter = new FilterBuilder()
        catFilter.where({ 'isActive': true })
        catFilter.where({ 'isDeleted': false })
        catFilter.where({ 'visible' : true })
        catFilter.order('name ASC')
        const resp = await api.Category.find(catFilter.build())
        if (resp.error) {
          console.error("Error retrieving categories: ", resp.error)
          return
        }

        console.log('categories', resp)

        if (settings.theme === THEMES.CASHBYCREATIVE) {
          resp.unshift({ id: 0, name: 'JUST ADDED', visible: true, isActive: true, isDeleted: false })
        }

        setCategories(resp)
      }
      getCats()
    }
  }, [isAuthenticated])

  const getServices = async () => {
    try {
      const filter = new FilterBuilder()
      const data = await api.ConciergeService.find(filter.build())
      if (data.error) {
        console.error("Error retrieving services", data)
        return
      }

      const filteredData = data.filter(service => service.vproAdtype.includes(theme.name))
      getUsedServices(filteredData)

      const staticServicesData = await conciergeServicesApi.getConciergeServices()

      if (filteredData) {
        const aggregatedServices = filteredData.map(el => {
          const matchingStaticObjs = staticServicesData.filter((c) => c.title == el.title)
          return {
            ...el,
            image: matchingStaticObjs.length > 0 ? matchingStaticObjs[0].image : staticServicesData[0].image
          }
        })

        setServices(aggregatedServices)
      }
    } catch (err) {
      console.error(err)
    }
  }

  const getUsedServices = async (services) => {
    try {
      // Count services used since the beginning of the current month
      const date = new Date()
      date.setDate(1)
      date.setHours(0, 0, 0, 0)

      const counts = await Promise.all(services.map(service => {
        /** @type FilterBuilder<import('../../../lib/backendApi/types/concierge').Concierge> */
        const filter = new FilterBuilder()
        filter.where({
          and: [
            { createdDate: { gte: date } },
            { conciergeServiceId: service.id },
            { isDeleted: false },
          ]
        })
        return api.Concierge.count(filter.build()).then(count => ({ serviceId: service.id, count }))
      }))

      setServiceUsedCounts(counts)
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    getServices()
  }, [])

  return (
      <div style={{ height: 'calc(100vh - 128px)' }}>
        <Helmet>
          <title>{`${theme.name || ""}`}</title>
        </Helmet>
        <FrontendHero categories={categories} services={services} />
      </div>
  );
};

export default Home;
